import { useQuery } from '@apollo/client';
import {
  ResourcePageListFilterInput,
  ResourcePageListSortingInput,
  ResourcesDocument,
  UserResourcesDocument,
} from 'src/graphql/generated/graphql';

interface UseResourcesProps {
  filter?: ResourcePageListFilterInput;
  sorting?: ResourcePageListSortingInput;
  pagination?: {
    limit: number;
    page: number;
    extraRows?: number;
  };
  skip?: boolean;
  isUserResources?: boolean;
}

export const useResources = (props?: UseResourcesProps) => {
  const { filter, sorting, pagination, skip, isUserResources } = props || {};
  const { limit = 100, page = 0, extraRows = 0 } = pagination || {};
  const offset = page * limit;

  const { data: resourcesData, loading: resourcesLoading } = useQuery(
    ResourcesDocument,
    {
      variables: {
        filter,
        sorting,
        pagination: { limit: limit + extraRows, offset },
      },
      skip: skip || isUserResources,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  const { data: userResourcesData, loading: userResourcesLoading } = useQuery(
    UserResourcesDocument,
    {
      variables: {
        filter,
        sorting,
        pagination: { limit: limit + extraRows, offset },
      },
      skip: skip || !isUserResources,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  return {
    resources: isUserResources
      ? userResourcesData?.userResources?.records || []
      : resourcesData?.resources?.records || [],
    totalCount: isUserResources
      ? userResourcesData?.userResources?.pagination?.totalCount || 0
      : resourcesData?.resources?.pagination?.totalCount || 0,
    loading: isUserResources ? userResourcesLoading : resourcesLoading,
  };
};
